// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabNavigationBottomFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  width: 100%;
  padding: 12px 0 7px 0px;
}

.tabNavigationBottomFooter button {
  color: #8f9bb3;
  font-size: 16px;
  cursor: pointer;
  background: none;
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

.tabNavigationBottomFooter button > i:before {
  margin-right: 0px;
  display: inline-block;
  font-size: 15px;
  padding: 8px;
  background-color: #36f;
  border-radius: 5px;
  color: #fff;
  vertical-align: initial;
}

.tabNavigationBottomFooter button > i:hover {
  color: #36f;
}

.tabNavigationBottomFooter button > i:before:hover {
  color: #fff;
}

.btn_icon_next {
  margin-left: auto;
}

@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .tabNavigationBottomFooter button {
    font-size: 0.85rem;
  }
  .tabNavigationBottomFooter button > i:before {
    font-size: 8px;
  }
}
.tabNavigationBottomFooter button .btn-arrow > i:before {
  margin-right: 0px;
  display: inline-block;
  font-size: 15px;
  padding: 8px;
  background-color: #36f;
  border-radius: 5px;
  color: #fff;
  vertical-align: initial;
}

.tabNavigationBottomFooter button .btn-arrow:focus i,
.tabNavigationBottomFooter button .btn-arrow i:focus,
.tabNavigationBottomFooter button .btn-arrow:hover i,
.tabNavigationBottomFooter button .btn-arrow i:hover {
  border: 3px solid #0b31a2;
  box-shadow: 0 5px 8px rgba(11, 49, 162, 0.3);
}

.abid {
  font-size: 18px;
}

.icon-left-arrow {
  background-image: url(/assets/theme/images/icon_left_arrow.png);
  width: 12px;
  height: 12px;
  background-repeat: no-repeat;
}

.next-bg-color,
.prev-bg-color {
  min-width: 120px;
  font-size: 19px;
  display: flex;
  justify-content: center;
  text-align: center;
  gap: 5%;
  color: white;
  font-weight: 500;
  letter-spacing: -0.025em;
  background-color: rgba(25, 14, 207, 0.8196078431);
  background-image: linear-gradient(324deg, hsl(204, 100%, 48%) 48%, transparent 66%);
  background-repeat: no-repeat;
  background-position: center 45%;
  background-size: 100% 200%;
  padding: 0.5rem;
  border-radius: 2em;
  border: none;
  box-shadow: 0 -0.5em 0.5em transparent, 0 0.5em 0.5em transparent, 0 0.25em 0.3em -0.2em hsla(190, 50%, 50%, 0.46), 0 0.25em 0.75em hsla(190, 40%, 40%, 0.3);
  height: 1.79rem;
  font-size: 0.9rem;
  line-height: 0.99;
  text-wrap: nowrap;
  padding: 0.45rem 1.12rem;
}

.next-bg-color:focus,
.next-bg-color:hover,
.prev-bg-color:focus,
.prev-bg-color:hover {
  border: 1px solid hsla(190, 40%, 40%, 0.73);
  box-shadow: 0em 0.5em 1.5em transparent, 0em 0.5em 2.5em transparent, 0.55em 0.55em 0.53em 0.12em hsla(190, 50%, 50%, 0.46), 1em 0.15em 0.75em hsla(190, 40%, 40%, 0.3);
}

.topBoderOnFooter {
  border-top: 1px solid #b2bed5;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/tab-container/tab-container.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;AACF;;AACA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;AAEF;;AAAA;EAkBE,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,WAAA;AAdF;;AAgBA;EACE,WAAA;AAbF;;AAgBA;EACE,iBAAA;AAbF;;AAgBA;EACE;IACE,kBAAA;EAbF;EAeA;IACE,cAAA;EAbF;AACF;AAgBA;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AAdF;;AAiBA;;;;EAIE,yBAAA;EACA,4CAAA;AAdF;;AAuCA;EACE,eAAA;AApCF;;AAuCA;EACE,+DAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;AApCF;;AAkDA;;EAME,gBAAA;EAIA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,iDAAA;EACA,mFAAA;EAKA,4BAAA;EACA,+BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,4JAAA;EAEA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;AA3DF;;AA8DA;;;;EAME,2CAAA;EACA,uKAAA;AA7DF;;AAiEA;EACE,6BAAA;AA9DF","sourcesContent":[".tabNavigationBottomFooter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 0;\r\n  width: 100%;\r\n  padding: 12px 0 7px 0px;\r\n}\r\n.tabNavigationBottomFooter button {\r\n  color: #8f9bb3;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  background: none;\r\n  box-shadow: none !important;\r\n  border: none !important;\r\n  outline: none !important;\r\n}\r\n.tabNavigationBottomFooter button > i:before {\r\n  // margin-right: 3px;\r\n  // display: inline-block;\r\n  // font-size: 16px;\r\n\r\n  // padding: 5px;\r\n  // background-color: #36f;\r\n  // border-radius: 3px;\r\n  // color: #fff;\r\n  // margin-right: 3px;\r\n  // display: inline-block;\r\n  // font-size: 10px;\r\n  // padding: 8px;\r\n  // background-color: #36f;\r\n  // border-radius: 3px;\r\n  // color: #fff;\r\n  // line-height: 1;\r\n  // vertical-align: middle;\r\n  margin-right: 0px;\r\n  display: inline-block;\r\n  font-size: 15px;\r\n  padding: 8px;\r\n  background-color: #36f;\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  vertical-align: initial;\r\n}\r\n\r\n.tabNavigationBottomFooter button > i:hover {\r\n  color: #36f;\r\n}\r\n.tabNavigationBottomFooter button > i:before:hover {\r\n  color: #fff;\r\n}\r\n\r\n.btn_icon_next {\r\n  margin-left: auto;\r\n}\r\n\r\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\r\n  .tabNavigationBottomFooter button {\r\n    font-size: 0.85rem;\r\n  }\r\n  .tabNavigationBottomFooter button > i:before {\r\n    font-size: 8px;\r\n  }\r\n}\r\n\r\n.tabNavigationBottomFooter button .btn-arrow > i:before {\r\n  margin-right: 0px;\r\n  display: inline-block;\r\n  font-size: 15px;\r\n  padding: 8px;\r\n  background-color: #36f;\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  vertical-align: initial;\r\n}\r\n\r\n.tabNavigationBottomFooter button .btn-arrow:focus i,\r\n.tabNavigationBottomFooter button .btn-arrow i:focus,\r\n.tabNavigationBottomFooter button .btn-arrow:hover i,\r\n.tabNavigationBottomFooter button .btn-arrow i:hover {\r\n  border: 3px solid #0b31a2;\r\n  box-shadow: 0 5px 8px rgba(11, 49, 162, 0.3);\r\n}\r\n\r\n// .tabNavigationBottomFooter button .prev-bg-color {\r\n//   color: white !important;\r\n//   background-color: #413e34 !important;\r\n//   border-radius: 9px;\r\n//   height: 36px;\r\n//   min-width: 100px;\r\n//   border: 1px solid transparent;\r\n//   border-radius: 5px;\r\n//   margin-right: 3px;\r\n//   padding: 6px 8px 6px 8px;\r\n//   font-size: 19px;\r\n//   display: flex;\r\n//   justify-content: center;\r\n//   text-align: center;\r\n//   gap: 5%;\r\n// }\r\n\r\n// .icon-arrow-size {\r\n//   font-size: 21px;\r\n//   display: flex;\r\n// }\r\n\r\n.abid {\r\n  font-size: 18px;\r\n}\r\n\r\n.icon-left-arrow {\r\n  background-image: url(/assets/theme/images/icon_left_arrow.png);\r\n  width: 12px;\r\n  height: 12px;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n// .tab-text-size {\r\n//   font-size: 1.01rem;\r\n//   text-wrap: nowrap;\r\n// }\r\n\r\n// .tabNavigationBottomFooter button .prev-bg-color:focus,\r\n// .tabNavigationBottomFooter button .prev-bg-color:hover {\r\n//   border: 3px solid #7e8b88;\r\n//   box-shadow: 0px 5px 8px rgb(11 49 162 / 30%);\r\n// }\r\n\r\n.next-bg-color,\r\n.prev-bg-color {\r\n  // color: white !important;\r\n  // background-color: #413e34 !important;\r\n  // border-radius: 9px;\r\n  // height: 36px;\r\n  min-width: 120px;\r\n  // border: 1px solid transparent;\r\n  // border-radius: 5px;\r\n  // padding: 6px 8px 6px 8px;\r\n  font-size: 19px;\r\n  display: flex;\r\n  justify-content: center;\r\n  text-align: center;\r\n  gap: 5%;\r\n  color: white;\r\n  font-weight: 500;\r\n  letter-spacing: -0.025em;\r\n  background-color: #190ecfd1;\r\n  background-image: linear-gradient(\r\n    324deg,\r\n    hsl(calc(141deg + 63deg) calc(99% + 20%) 48%) 48%,\r\n    transparent calc(100% - 34%)\r\n  );\r\n  background-repeat: no-repeat;\r\n  background-position: center 45%;\r\n  background-size: 100% 200%;\r\n  padding: 0.5rem;\r\n  border-radius: 2em;\r\n  border: none;\r\n  box-shadow: 0 -0.5em 0.5em transparent, 0 0.5em 0.5em transparent,\r\n    0 0.25em 0.3em -0.2em hsla(190deg, 50%, 50%, 0.46), 0 0.25em 0.75em hsla(190deg, calc(50% - 10%), 40%, 0.3);\r\n  height: 1.79rem;\r\n  font-size: 0.9rem;\r\n  line-height: 0.99;\r\n  text-wrap: nowrap;\r\n  padding: 0.45rem 1.12rem;\r\n}\r\n\r\n.next-bg-color:focus,\r\n.next-bg-color:hover,\r\n.prev-bg-color:focus,\r\n.prev-bg-color:hover {\r\n  // border: 3px solid #7e8b88;\r\n  // box-shadow: 0px 5px 8px rgb(11 49 162 / 30%);\r\n  border: 1px solid hsla(190, 40%, 40%, 0.73);\r\n  box-shadow: 0em 0.5em 1.5em transparent, 0em 0.5em 2.5em transparent,\r\n    0.55em 0.55em 0.53em 0.12em hsla(190, 50%, 50%, 0.46), 1em 0.15em 0.75em hsla(190, 40%, 40%, 0.3);\r\n}\r\n\r\n.topBoderOnFooter {\r\n  border-top: 1px solid #b2bed5;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
